// Generated by CoffeeScript 1.9.3
(function() {
  var BigNumber, i, instagramIdToUrlSegment, map, o, reversedMap, urlSegmentToInstagramId;

  BigNumber = require('bignumber.js');

  map = require('./charmap');

  reversedMap = {};

  for (i in map) {
    o = map[i];
    reversedMap[o] = i;
  }

  instagramIdToUrlSegment = function(id) {
    var char, j, len, urlSegment;
    id = (new BigNumber(id)).toString(64);
    urlSegment = '';
    for (j = 0, len = id.length; j < len; j++) {
      char = id[j];
      urlSegment += map[char];
    }
    return urlSegment;
  };

  urlSegmentToInstagramId = function(urlSegment) {
    var char, id, j, len;
    id = '';
    for (j = 0, len = urlSegment.length; j < len; j++) {
      char = urlSegment[j];
      id += reversedMap[char];
    }
    id = (new BigNumber(id, 64)).toString(10);
    return id;
  };

  module.exports = {
    instagramIdToUrlSegment: instagramIdToUrlSegment,
    urlSegmentToInstagramId: urlSegmentToInstagramId
  };

}).call(this);
